import { TFunction } from 'i18next';
import { Button, Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import classes from './ShareModal.module.scss';
import { SharedLinkAPI } from './types';
import Assets from 'assets/icons';

export const getShareManagementColumns = (t: TFunction, onRevoke?: (id: string) => void, onCopyLink?: (link: SharedLinkAPI) => void) => [
  {
    title: t('Documents.modals.share.management.fullName'),
    dataIndex: 'userName',
    key: 'userName',
    render: (value: string | null | undefined, record: any) => (
      record.status !== 'expired' && (
     <div className={classes.rowWrap}>
        <Tooltip title={t('Users.table.inviteLink.copyLink')}>
          <Button
            type='text'
            size='middle'
            className={classes.copyLinkBtn}
            icon={<CopyOutlined className={classes.linkIcon} />}
            onClick={() => onCopyLink?.(record.rawLink)}
          />
        </Tooltip>
        {value ? <span>{value}</span> : <span className={classes.emptyCell}>—</span>}
      </div>)
    ),
  },
  {
    title: t('Documents.modals.share.management.email'),
    dataIndex: 'email',
    key: 'email',
    render: (value: string | null | undefined) =>
      value ? value : <span className={classes.emptyCell}>—</span>,
  },
  {
    title: t('Documents.modals.share.management.status'),
    dataIndex: 'status',
    key: 'status',
    render: (status: string) => (
      <span className={status === 'active' ? classes.statusActive : classes.statusExpired}>
        {t(`Documents.modals.share.management.statusValues.${status}`)}
      </span>
    ),
  },
  {
    title: t('Documents.modals.share.management.actions'),
    key: 'actions',
    render: (_: any, record: any) => (
      record.status === 'active' ? (
        <Button 
          type='link' 
          size='small' 
          danger
          icon={<Assets.TrashIcon className={classes.trashIcon}/>} 
          onClick={() => onRevoke?.(record.key)}
        >
          {t('Documents.modals.share.management.revoke')}
        </Button>
      ) : null
    ),
  },
]; 
